import { useState } from 'react';
import { TYPE_BUTTONS } from '../../../../constans';
import Row from '../../Blocks/Row';
import AnimateArrow from '../../Buttons/AnimateArrow';
import Button from '../../Buttons/Button';
import styles from './styles.module.scss';

import ContextMenuBase from './Base';
import ContextMenuLine from './Base/ContextMenuLine';

const ContextMenu = ({ list = [], ...props }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={styles.menu_button} {...props}>
      <Button type={TYPE_BUTTONS.BLUE} onClick={() => setIsOpen(!isOpen)}>
        <Row>
          <div style={{ marginRight: '5px' }}> {props.children}</div>{' '}
          <AnimateArrow isOpen={isOpen} is_white={true} style={{ height: '9px' }} />
        </Row>
      </Button>
      {isOpen && (
        <ContextMenuBase close={() => setIsOpen(false)} className={styles.template_setting_menu}>
          {list
            .filter(item => !item.isHidden)
            .map((item, k) => (
              <ContextMenuLine
                key={k}
                withImg={false}
                text={item.text}
                styles={styles.flex_end}
                onClick={() => {
                  item.callback();
                  setIsOpen(false);
                }}
              />
            ))}
        </ContextMenuBase>
      )}
    </div>
  );
};

export default ContextMenu;
